<template>
  <ValidationObserver ref="observer">
    <div>
      <b-card>
        <b-row>
          <b-col md="9">
            <h4 class="text-black font-weight-bold">Update Unit Info</h4>
          </b-col>
          <b-col md="3">
            <h4>Unit Type: {{ unitTitle }}</h4>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <c-input inputType="text" lableText="Unit #" v-model="unit" />
          </b-col>
          <b-col>
            <c-input
              inputType="text"
              lableText="Square Footage"
              v-model="squareFoot"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <c-input inputType="text" lableText="Block" v-model="block" />
          </b-col>
          <b-col>
            <c-input inputType="text" lableText="Floor" v-model="floor" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label>Description</label>
            <textarea
              class="form-control"
              rows="4"
              cols="50"
              id="description"
              maxlength="1500"
              v-model="description"
              placeholder="Tell us about your unit"
            ></textarea>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label class="text-black">Select Unit Type</label>
            <br />
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Unit Type"
            >
              <b-form-radio-group
                id="radio-group-2"
                name="radio-sub-component"
                v-model="selectedRadio"
              >
                <b-form-radio
                  name="some-radios"
                  value="Furnished Apartment"
                  class="text-black"
                  >Furnished Apartment</b-form-radio
                >
                <b-form-radio
                  name="some-radios"
                  value="Unfurnished Apartment"
                  class="text-black"
                  >Unfurnished Apartment</b-form-radio
                >
                <b-form-radio
                  name="some-radios"
                  value="Full Serviced Apartment"
                  class="text-black"
                  >Full Serviced Apartment</b-form-radio
                >
              </b-form-radio-group>
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row
          ><b-col>
            <h4>Unit Photo</h4>
            <single-image
              class="singleImage"
              height="147px"
              width="147px"
              @change="(d) => uploadImage('unitPhoto', d)"
              :id="'unitPhoto'"
              ref="unitPhoto"
              :url="unitPhoto"
              label="Browse Unit Photo"
            ></single-image> </b-col
        ></b-row>

        <b-row class="justify-content-center mt-4">
          <b-button
            variant="danger"
            class="mr-2"
            @click="$router.push({ name: 'Unit Management' })"
            >CANCEL</b-button
          >
          <div v-if="isLoading" class="spinner-overlay">
            <div class="spinner"></div>
          </div>
          <b-button variant="success" @click="updateUnitData">UPDATE</b-button>
        </b-row>
      </b-card>
    </div>
  </ValidationObserver>
</template>

<script>
import cInput from "@/components/FormElements/CustomInput";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";
export default {
  components: {
    SingleImage,
    cInput,
    ValidationProvider,
    ValidationObserver,
    Validator,
  },
  data() {
    return {
      unit: "",
      block: "",
      floor: "",
      squareFoot: "",
      description: "",
      unitTitle: "",
      unitPhoto: null,
      selectedRadio: "",
      unsuppportedFile: false,
      catalogId: "",
      provider: "",
      unitDetail: null,
      isLoading: false,
    };
  },
  methods: {
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      if (!image.includes("data:image")) {
        this.unitPhoto = null;
        this.unsuppportedFile = true;

        return;
      }
      this.unsuppportedFile = false;
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["agent", "unitPhoto"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.unitPhoto = res.data.fileUrl;
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    async updateUnitData() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      const payload = {
        id: this.$route.params.id,
        data: {
          unitNo: this.unit,
          Block: this.block,
          Floor: this.floor,
          Name: this.unitTitle,
          description_summary: this.unitTitle,
          providerName: "static",
          provider: this.provider,
          catalogId: this.catalogId,
          images: {
            icon: this.unitPhoto,
            smallImage: this.unitPhoto,
            bigImage: this.unitPhoto,
            alternateImages: [
              {
                type: "unit",
                fileUrl: this.unitPhoto,
                url: this.unitPhoto,
                fileName: "waste-mana...",
                fileSize: "0.03",
              },
              {
                type: "floor",
                fileUrl:
                  "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966861933",
                url: "https://calonex-dev.s3.amazonaws.com/images/seller/items/1727966861933",
                fileName: "waste-mana...",
                fileSize: "0.03",
              },
            ],
          },
          securityAmount: 3433,
          applicationFee: 23,
          productType: "Normal",
          Type: "UNIT",
          Description: this.description,
          squareFoot: this.squareFoot,
          Bathrooms: this.unitDetail.Bathrooms,
          Bedrooms: this.unitDetail.Bedrooms,
          AvailableFrom: "2024-10-03",
          LateFee: { value: "0", valueType: "percent" },
          Price: 100,
          unitType: this.selectedRadio,
          City: "Ghatal",
          Country: "India",
          State: "West Bengal",
          Lng: 0,
          Lat: 0,
          createdAt: "2024-10-03T14:47:54.433Z",
          Area: "Ghatal, West Bengal, 55997, undefined",
          Occupancy: "VACANT",
          isDeleted: false,
          creditReport: false,
          cxScore: false,
          "Discount(%)": "0",
        },
      };
      this.$store.dispatch("unit/updateUnit", payload).then((res) => {
        this.isLoading = false;
        this.$swal({
          title: "Success",
          text: "Unit Updated successfully!!",
          type: "success",
        });
        this.$router.push({ path: "/unit" });
      });
    },
    async unitDetails() {
      await this.$store
        .dispatch("unit/unitData", this.$route.params.id)
        .then((response) => {
          response.map((res) => {
            this.unitTitle = res.UnitTitle || "";
            this.unit = res.unitNo || "";
            this.block = res.Block || "";
            this.floor = res.Floor || "";
            this.squareFoot = res.squareFoot || "0";
            this.description = res.Description || "";
            this.unitPhoto =
              res?.product_summary?.images?.alternateImages[0]?.url || "";
            this.provider = res.provider || "";
            this.catalogId = res.catalogId || "";
            this.selectedRadio = res.unitType || "";
          });
        });
    },
  },
  mounted() {
    this.unitDetails();
    this.unitDetail = this.$route.params.data;
  },
};
</script>

<style>
.singleImage {
  height: 200px;
  border-radius: 12px;
  border: 1px dashed #3635d3 !important;
  background-color: #e9e7ff;
}
</style>
